<template>
  <multiselect
    v-model="selectedSpecialities"
    :id="this.$props.id ? this.$props.id : 'ajax'"
    placeholder=""
    open-direction="bottom"
    :options="specialityList"
    :multiple="true"
    :searchable="true"
    :disabled="this.$props.disabled"
    :loading="isLoading"
    :internal-search="false"
    :clear-on-select="false"
    :close-on-select="true"
    @close="handleSelect"
    :options-limit="200"
    :limit="200"
    :limit-text="limitText"
    :deselect-label="'Remover item'"
    label="name"
    track-by="id"
    :selected-label="'Selecionado'"
    :select-label="'Selecionar'"
    :max-height="600"
    :show-no-results="true"
    @search-change="asyncFind"
    @remove="removeElement"
  >
    <template #noOptions>
      <span class="custom-no-options"
        >Comece a escrever para inciar consulta.</span
      >
    </template>
    <template #clear="props">
      <div
        class="multiselect__clear"
        v-if="selectedSpecialities.length"
        @mousedown.prevent.stop="clearAll(props.search)"
      ></div>
    </template>
    <span slot="noResult"
      >Nenhuma especialidade encontrada, tente refazer a consulta.</span
    >
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import { createToast } from "../toast/toast";
import { getSpecialties } from "../../services/training/trainingManagementService";

export default {
  components: { Multiselect },
  props: ["items", "toRemove", "toOnly", "disabled", "id"],
  mounted() {
    this.selectedSpecialities = this.$props.items;

    if (!this.$props.disabled) this.getAllSpecialityToCache();
  },
  data() {
    return {
      selectedSpecialities: [],
      specialityList: [],
      specialtiesListAll: [],
      isLoading: false,
    };
  },
  methods: {
    removeElement(elementToRemove) {
      const newList = this.selectedSpecialities.filter(
        (item) => item !== elementToRemove,
      );
      console.log("newList event", newList);
      if (newList.length !== this.selectedSpecialities.length) {
        this.selectedSpecialities = newList;
        this.$emit("onSelect", this.selectedSpecialities);
      }

      this.specialityList = this.specialtiesListAll.filter(
        (item) => !this.selectedSpecialities.includes(item),
      );
    },
    handleSelect() {
      this.specialityList = this.specialtiesListAll.filter(
        (item) => !this.selectedSpecialities.includes(item),
      );
      this.$emit("onSelect", this.selectedSpecialities);
    },
    limitText(count) {
      return `e ${count} outras especialidades`;
    },
    getAllSpecialityToCache() {
      this.isLoading = true;
      getSpecialties()
        .then((response) => {
          this.specialtiesListAll = this.onSpecialtiesDescriptions(response);
          this.specialityList = this.specialtiesListAll;
          this.isLoading = false;
          this.handleSelect();
        })
        .catch((err) => {
          createToast("Erro", "Não foi possível consultar as especialidades.");
          console.error("getAllSpecialityToCache", err);
          this.isLoading = false;
        });
    },
    isArrayEmpty(arr) {
      return !arr?.length;
    },
    onSpecialtiesDescriptions(specialties) {
      return [
        ...specialties.map((sp) => {
          return { id: sp.code, name: sp.description };
        }),
      ];
    },
    asyncFind(query) {
      let filteredList = this.specialtiesListAll.filter((item) =>
        item.name.toUpperCase().includes(query.toUpperCase()),
      );

      if (!this.isArrayEmpty(this.$props.toOnly)) {
        filteredList = filteredList.filter((item) =>
          this.$props.toOnly.includes(item),
        );
      } else if (!this.isArrayEmpty(this.$props.toRemove)) {
        filteredList = filteredList.filter(
          (item) =>
            !this.selectedSpecialities.includes(item) &&
            !this.$props.toRemove.includes(item),
        );
      } else {
        filteredList = filteredList.filter(
          (item) => !this.selectedSpecialities.includes(item),
        );
      }

      this.specialityList = filteredList;
    },
    clearAll() {
      this.selectedSpecialities = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-icon-remove {
  margin-bottom: 2.8px;
  margin-left: 1.5px;
  margin-right: 2px;
}
</style>
<style lang="scss">
.multiselect__tag {
  background-color: #e6e6e6;
  color: #23272b;
  border-radius: 10px;
}
.multiselect__tag-icon:hover {
  background: #bccac4;
}
.multiselect__tag-icon:after {
  color: #23272b;
}
</style>
